export const UTM_PARAMS: string[] = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export const DEFAULT_UTM_PARAM_VALUES: Record<string, null> = Object.freeze({
  utmSource: null,
  utmMedium: null,
  utmCampaign: null,
  utmTerm: null,
  utmContent: null,
});

export const UTM_PARAMS_NAMES: Record<string, string> = {
  utm_source: 'UTM_Source',
  utm_medium: 'UTM_Medium',
  utm_campaign: 'UTM_Campaign',
  utm_term: 'UTM_Term',
  utm_content: 'UTM_Content',
};
